import { Text } from "@radix-ui/themes";
import { useBrand } from "@/shared/brand/useBrand";

// Under every page of a branded site: whose platform it is, and the way back
// to the customer's own website. Nothing on Driftables itself. Mirrors
// layouts/_brand_footer.html.erb.
export default function BrandFooter() {
  const brand = useBrand();
  if (!brand) return null;

  return (
    <footer className="mt-16 border-t border-gray5 bg-panel">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-x-6 gap-y-2 px-4 py-5">
        <Text size="2" color="gray">
          Powered by Driftables ·{" "}
          {/* Plain anchors: the legal pages aren't Inertia pages. */}
          <a href="/terms" className="hover:underline">Terms</a> ·{" "}
          <a href="/privacy" className="hover:underline">Privacy</a>
        </Text>
        {brand.website_url && (
          <Text size="2">
            <a href={brand.website_url} className="text-accent11 hover:underline">
              Back to {brand.name}
            </a>
          </Text>
        )}
      </div>
    </footer>
  );
}
